
export const randomArrayElement = inputArray =>
  inputArray[Math.floor(Math.random() * inputArray.length)]
